import './dialog.css';

import React from 'react';

import { cn } from '@/services/utils';

import { TabsList, TabsTrigger } from '../Tabs';

const DialogTabsList = React.forwardRef<
    React.ElementRef<typeof TabsList>,
    React.ComponentPropsWithoutRef<typeof TabsList>
>(({ className, ...props }, ref) => (
    <TabsList
        ref={ref}
        className={cn(
            'tw-absolute tw-h-auto tw-left-[-48px] tw-top-2 tw-flex-col tw-bg-gray-200 tw-p-0',
            className
        )}
        {...props}
    />
));

DialogTabsList.displayName = 'DialogTabsList';

const DialogTabsTrigger = React.forwardRef<
    React.ElementRef<typeof TabsTrigger>,
    React.ComponentPropsWithoutRef<typeof TabsTrigger>
>(({ className, ...props }, ref) => (
    <TabsTrigger
        ref={ref}
        className={cn(
            `scoped-dialog-tabs-trigger
             tw-p-4
             tw-text-base
             tw-bg-gray-200
             tw-drop-shadow-none
             focus-visible:!tw-outline-none
             focus-visible:!tw-ring-0 focus-visible:!tw-ring-offset-0
             focus-visible:!tw-border-solid focus-visible:!tw-border-2 focus-visible:!tw-border-primary-focus
             data-[state=active]:tw-shadow-none data-[state=inactive]:tw-shadow-none
             data-[state=active]:tw-text-gray-800 data-[state=active]:tw-bg-gray-300
             data-[state=inactive]:tw-text-gray-400 data-[state=inactive]:tw-bg-gray-200`,
            className
        )}
        {...props}
    />
));

DialogTabsTrigger.displayName = 'TabsTrigger';

export { DialogTabsList, DialogTabsTrigger };
